module.exports = __webpack_public_path__ + "img/formato-mobile.fcd591f1.png";